import { avatarSwatch } from '../lib/avatarColor'

// Circular avatar with initials fallback (no photos in seed data).
// `id` seeds the color palette so the same user is always the same color.
export default function Avatar({
  id,
  name,
  size = 'sm',
}: {
  id: number | string
  name: string
  size?: 'sm' | 'md' | 'lg'
}) {
  const initials = name
    .split(/\s+/)
    .map((p) => p[0])
    .filter(Boolean)
    .slice(0, 2)
    .join('')
    .toUpperCase()
  const dim =
    size === 'lg'
      ? 'h-10 w-10 text-sm'
      : size === 'md'
        ? 'h-9 w-9 text-xs'
        : 'h-6 w-6 text-[10px]'
  const swatch = avatarSwatch(id)
  return (
    <span
      className={`flex shrink-0 items-center justify-center rounded-full font-display font-semibold ${dim}`}
      style={{ backgroundColor: swatch.bg, color: swatch.text }}
    >
      {initials}
    </span>
  )
}
